/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Invite_Error_BodyInputs */



/**
* | output |
* | --- |
* | "This invitation link is no longer valid. Please request a new invite." |
*
* @param {Partner_Invite_Error_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_invite_error_body = /** @type {((inputs?: Partner_Invite_Error_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Invite_Error_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Einladungslink ist nicht mehr gültig. Bitte fordere eine neue Einladung an.")
	return /** @type {LocalizedString} */ ("This invitation link is no longer valid. Please request a new invite.")
});